'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $f_Lapp_auth_OperationalUserWithClient$Pharmacy__displayName__T($thiz) {
  return $thiz.server__Lapp_data_OperationalAppRegisteredUser$Pharmacy().Lapp_data_OperationalAppRegisteredUser$Pharmacy__f_server.displayName__T();
}
export { $f_Lapp_auth_OperationalUserWithClient$Pharmacy__displayName__T as $f_Lapp_auth_OperationalUserWithClient$Pharmacy__displayName__T };
function $is_Lapp_auth_OperationalUserWithClient$Pharmacy(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lapp_auth_OperationalUserWithClient$Pharmacy)));
}
export { $is_Lapp_auth_OperationalUserWithClient$Pharmacy as $is_Lapp_auth_OperationalUserWithClient$Pharmacy };
function $isArrayOf_Lapp_auth_OperationalUserWithClient$Pharmacy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_auth_OperationalUserWithClient$Pharmacy)));
}
export { $isArrayOf_Lapp_auth_OperationalUserWithClient$Pharmacy as $isArrayOf_Lapp_auth_OperationalUserWithClient$Pharmacy };
//# sourceMappingURL=app.auth.-Operational-User-With-Client$-Pharmacy.js.map
